module.exports = __webpack_public_path__ + "skins/Green-Dimension-V2-4308a2fc648033bf5fe7c4d56a5c8823.wsz";


//////////////////
// WEBPACK FOOTER
// ./skins/Green-Dimension-V2.wsz
// module id = 138
// module chunks = 5